import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

const STCPromoCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
  }
`;

const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  align-self: flex-end;
  width: 100%;
  text-transform: uppercase;
  min-width: auto !important;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
    max-width: 200px;
  }
`;

const BoldTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-right: 34px;
  }
`;

const PromoText = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: var(--cvna-color-blue-6);
`;

const PromoSubText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  margin-bottom: 0;
`;

export {
  STCPromoCardWrapper,
  ContentWrapper,
  Content,
  Button,
  BoldTitle,
  TextContainer,
  PromoText,
  PromoSubText,
};
